import { useQueryOrganizationName } from '../../models/useQueryOrganizationName'

export const useOrganizationNameSystemPreferencePresenter = (): {
  data: { organizationName: Nullable<string> }
  states: { isLoading: boolean; isError: boolean }
} => {
  const { organizationName, isLoading, isError } = useQueryOrganizationName()

  return {
    data: { organizationName },
    states: { isLoading, isError },
  }
}
